<template>
  <div
    class="bg-[#0F0F0F] text-white font-sora min-h-screen py-16 px-6 sm:px-10 lg:px-40"
  >
    <!-- Başlık -->
    <div class="text-center mb-12">
      <h1 class="text-4xl md:text-5xl font-extrabold text-[#3DCBB1]">
        {{ $t("career.title") }}
      </h1>
      <p class="mt-4 text-gray-400 text-lg max-w-3xl mx-auto">
        {{ $t("career.subtitle") }}
      </p>
    </div>

    <!-- Biyografi Bölümü -->
    <div class="bg-[#161616] rounded-xl p-8 shadow-md space-y-4 mb-12">
      <p class="text-lg leading-relaxed text-gray-300">
        {{ $t("career.bio_1") }}
      </p>
      <p class="text-lg text-gray-300">
        {{ $t("career.bio_2") }}
      </p>
    </div>

    <!-- Başarılar Zaman Çizgisi -->
    <div class="space-y-6">
      <h2 class="text-2xl font-semibold text-[#3DCBB1] mb-4">
        {{ $t("career.achievements_title") }}
      </h2>

      <!-- Bu kısmı i18n yapmadan bırakıyoruz çünkü dinamik / karmaşık liste -->
      <ul class="space-y-4 border-l border-[#3DCBB1] pl-6 text-gray-300">
        <li>
          {{ $t("career.achievements[0][0]") }}
          <b class="text-white">{{ $t("career.achievements[0][1]") }}</b>
        </li>
        <li>
          {{ $t("career.achievements[1][0]") }}
          <b class="text-white">{{ $t("career.achievements[1][1]") }}</b>
        </li>
        <li>
          {{ $t("career.achievements[2][0]") }}
          <b class="text-white">{{ $t("career.achievements[2][1]") }}</b>
        </li>
        <li>
          {{ $t("career.achievements[3][0]") }}
          <b class="text-white">{{ $t("career.achievements[3][1]") }}</b>
        </li>
        <li>
          {{ $t("career.achievements[4][0]") }}
          <b class="text-white">{{ $t("career.achievements[4][1]") }}</b>
        </li>
        <li>
          {{ $t("career.achievements[5][0]") }}
          <b class="text-white">{{ $t("career.achievements[5][1]") }}</b>
        </li>
        <li>
          {{ $t("career.achievements[6][0]") }}
          <b class="text-white">{{ $t("career.achievements[6][1]") }}</b>
        </li>
        <li>
          {{ $t("career.achievements[7][0]") }}
          <b class="text-white">{{ $t("career.achievements[7][1]") }}</b>
        </li>
        <li>
          {{ $t("career.achievements[8][0]") }}
          <b class="text-white">{{ $t("career.achievements[8][1]") }}</b>
        </li>
        <li>
          {{ $t("career.achievements[9][0]") }}
          <b class="text-white">{{ $t("career.achievements[9][1]") }}</b>
        </li>
      </ul>
      <h2 class="text-2xl font-semibold text-[#3DCBB1] mb-4">
        {{ $t("career.world_championship_title") }}
      </h2>
      <ul class="space-y-4 border-l border-[#3DCBB1] pl-6 text-gray-300">
        <li>
          {{ $t("career.world_championship_list[0][0]") }}
          <b class="text-white">{{
            $t("career.world_championship_list[0][1]")
          }}</b>
        </li>
        <li>
          {{ $t("career.world_championship_list[1][0]") }}
          <b class="text-white">{{
            $t("career.world_championship_list[1][1]")
          }}</b>
        </li>
        <li>
          {{ $t("career.world_championship_list[2][0]") }}
          <b class="text-white">{{
            $t("career.world_championship_list[2][1]")
          }}</b>
        </li>
        <li>
          {{ $t("career.world_championship_list[3][0]") }}
          <b class="text-white">{{
            $t("career.world_championship_list[3][1]")
          }}</b>
        </li>
        <li>
          {{ $t("career.world_championship_list[4][0]") }}
          <b class="text-white">{{
            $t("career.world_championship_list[4][1]")
          }}</b>
        </li>
        <li>
          {{ $t("career.world_championship_list[5][0]") }}
          <b class="text-white">{{
            $t("career.world_championship_list[5][1]")
          }}</b>
        </li>
        <li>
          {{ $t("career.world_championship_list[6][0]") }}
          <b class="text-white">{{
            $t("career.world_championship_list[6][1]")
          }}</b>
        </li>
      </ul>
    </div>

    <!-- CTA Buton -->
    <div class="mt-16 text-center">
      <h3 class="text-2xl font-semibold text-white mb-4">
        {{ $t("career.cta_title") }}
      </h3>
      <NuxtLink
        to="/block"
        class="inline-block bg-[#3DCBB1] hover:bg-[#2ca893] text-black font-semibold py-3 px-6 rounded-full text-lg transition"
      >
        {{ $t("career.cta_button") }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "default",
});
</script>

<style scoped>
/* Tailwind yeterli */
</style>
